export default __webpack_public_path__ + "static/media/misc-pantry2.4ba3d646.jpg";